import { render, staticRenderFns } from "./SithMesPrdSdProjectList.vue?vue&type=template&id=4b70be35&"
import script from "./SithMesPrdSdProjectList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdSdProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports